import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import QuickFilterCheckbox from 'components/QuickFilterCheckbox';

import './styles.css';

const QuickFilters = props => {
  const onChange = useCallback(
    (field, value, checked) => {
      props.onChangeHandler(field, checked);
    },
    [props.onChangeHandler]
  );

  const items = useMemo(() => {
    return props.filters.map((f, index) => (
      <QuickFilterCheckbox
        key={index}
        title={f.title}
        checked={f.checked}
        name={f.name}
        onChangeHandler={onChange}
        tooltipText={f.tooltip}
      />
    ));
  }, [props.filters, onChange]);

  return (
    <div>
      <h4 className="quick-filters__title">Quick Filters</h4>
      <div className="quick-filters__wrapper">{items}</div>
    </div>
  );
};

QuickFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      tooltip: PropTypes.string.isRequired,
      checked: PropTypes.bool,
    })
  ).isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};
export default QuickFilters;
